export enum PosDefaultScreenEnum {
  menu = 'menu',
  table = 'table'
}
